/** @jsx jsx */
import { jsx } from '@emotion/react';

import type { ComponentProps } from 'react';
import { useState } from 'react';

import { CollectionsModule } from '@coursera-web/cds-labs';

type Props = ComponentProps<typeof CollectionsModule>;

const ManagedCollectionsModule = (props: Props) => {
  const { onFilterChange, collections, ...rest } = props;

  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleFilterChange = async (index: number, filterName: string) => {
    onFilterChange?.(index, filterName);
    setSelectedIndex(index);
  };

  const currentCollections = collections ? [collections?.[selectedIndex]] : collections;

  return (
    <CollectionsModule
      {...rest}
      collections={currentCollections}
      currentCollectionSetIndex={selectedIndex}
      onFilterChange={handleFilterChange}
    />
  );
};

export default ManagedCollectionsModule;
